<template>
    <az-container>
        <az-form>
            <div class="li-tabela">
                <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false"
                              no-data-text="Não há licitações cadastradas" :style="cssVar"
                              hide-actions class="az-table-list table-licitacoes">
                    <template slot="items" slot-scope="props">
                        <td>
                            {{ props.item.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss')}}
                        </td>
                        <td>
                            <span>E - </span>{{ props.item.numeroEdital }}
                            <span>
                              <p>
                                <strong>P - {{ props.item.numeroProcesso }}</strong>
                              </p>
                            </span>
                        </td>
                        <td>
                            <span v-if="props.item.modalidade">
                                {{ getModalidadeLicitacao(props.item.modalidade) }}
                            </span>
                            <span v-else><strong>--</strong></span>
                        </td>
                        <td>
                            <expandir-texto :texto="props.item.objeto" tamanho="150"></expandir-texto>
                        </td>
                        <td>
                            <span v-if="props.item.responsavel">
                                {{ props.item.responsavel}}
                            </span>
                            <span v-else><strong>--</strong></span>
                        </td>
                        <td class="this-table-actions">
                            <v-tooltip top v-az-auth="'Licitacao.Visualizar'">
                                <a slot="activator" @click="$emit('visualizar',props.item.id)">
                                    <v-icon>search</v-icon>
                                </a>
                                Visualizar
                            </v-tooltip>
                        </td>
                        <td style="width: 5px">
                        </td>
                    </template>
                </v-data-table>
                <div class="az-pagination">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas" :total-visible="14" class="pagination-control"/>
                    <div class="az-select-pagination pl-3">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
import {mapState} from 'vuex'
import ExpandirTexto from '@/commons/components/ExpandirTexto.vue'
import {modalidadesLicitacao} from '@/commons/constants'

export default {
    name: 'ConsultasListagemTabela',
    components: {ExpandirTexto},
    props: ['itens', 'paginacao', 'paginas', 'totalItens', 'modoCriacao'],
    data() {
        return {
            modalidadesLicitacao,
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
            colunas: [
                {
                    text: 'Data/Hora Abertura',
                    value: 'dataPublicacao',
                    sortable: false,
                    align: 'left',
                    width: '100px',
                    class: 'primary--text'
                },
                {
                    text: this.tituloColunaEdital,
                    value: 'numeroEdital',
                    sortable: false,
                    align: 'left',
                    width: '170px',
                    class: 'primary--text'
                },
                {
                    text: 'Modalidade',
                    value: 'modalidade',
                    sortable: false,
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    text: 'Objeto',
                    value: 'objeto',
                    sortable: false,
                    align: 'left',
                    width: '180px',
                    class: 'primary--text'
                },
                {
                    text: 'Responsável',
                    value: 'responsavel',
                    sortable: false,
                    align: 'left',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'left',
                    width: '110px',
                    class: 'primary--text'
                }
            ]
        }
    },
    created() {
        this.colunas[1].text = this.tituloColunaEdital
    },
    methods: {
        getModalidadeLicitacao(modalidade) {
            return this.modalidadesLicitacao[modalidade]
        },
    },
    computed: {
        tituloColunaEdital() {
            return 'Edital/Processo'
        },
        cssVar() {
            return {
                '--label-coluna-edital': `"${this.tituloColunaEdital}"`
            }
        },
        ...mapState(['loki'])
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>
<style scoped lang="stylus">
.status
    span
        color: #777777

        i
            display: none

.status-active
    a
        text-decoration: none
        position: relative
        top: -5px
        color: #c6762b !important

        i
            position: relative
            top: 5px
            font-size: 26px
            color: #c6762b !important
            text-decoration: none

.table-licitacoes
    .acao-mobile
        display none

    td:hover
        cursor pointer !important

@media (max-width: 720px)
    .table-licitacoes
        td:nth-of-type(1):before
            content: "Data/Hora Abertura:"

        td:nth-of-type(2):before
            content: var(--label-coluna-edital)

        td:nth-of-type(3):before
            content: "Objeto:"

        td:nth-of-type(4):before
            content: "Responsável:"

        td:nth-of-type(5):before
            content: "Situação:"

        td:nth-of-type(6):before
            display none

        .acao-mobile
            display inline-block
            margin-left 3px

    .this-table-actions
        text-align: left !important;

        i
            font-size 20px !important

        a
            margin 0 !important

    .az-table-list tbody tr td
        padding: 2px 10px !important

    .status-active
        a
            text-decoration: none
            color: #777 !important
            position: relative
            top: 0

            i
                display none

.blob {
    border-radius: 50%;
    margin: 10px;
    height: 14px;
    width: 14px;
    transform: scale(1);
}

.blob.laranja {
    box-shadow: 0 0 0 0 rgba(255, 121, 63, 1);
    animation: pulse-laranja 2s infinite;
}

@keyframes pulse-laranja {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 121, 63, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 121, 63, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 121, 63, 0);
    }
}

.blub {
    border-radius: 50%;
    margin: 10px;
    height: 14px;
    width: 14px;
    transform: scale(1);
}

.azul {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 1);
    animation: pulse-azul 2s infinite;
}

.pagination-control {
    overflow-x: auto
    white-space: nowrap
}

@keyframes pulse-azul {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(33, 150, 243, .8);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(33, 150, 243, 0);
    }

    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
    }
}
</style>
